import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {RouterLink} from '@angular/router';

export interface ShellSubnavLink {
  label: string;
  route: string;
  icon?: string;
  exact?: boolean;
  matchPrefixes?: string[];
}

@Component({
  selector: 'app-shell-subnav',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './shell-subnav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellSubnavComponent {
  tabs = input.required<ShellSubnavLink[]>();
  currentPath = input.required<string>();
  tabClick = output<void>();

  isActive(tab: ShellSubnavLink): boolean {
    const path = this.currentPath();
    if (tab.matchPrefixes?.some(prefix => path === prefix || path.startsWith(`${prefix}/`))) {
      return true;
    }
    if (tab.exact) {
      return path === tab.route;
    }
    return path === tab.route || path.startsWith(`${tab.route}/`);
  }

  onTabClick(): void {
    this.tabClick.emit();
  }
}
